import { render, staticRenderFns } from "./ConversorPantalla.vue?vue&type=template&id=550f24cc&scoped=true&"
import script from "./ConversorPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConversorPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f24cc",
  null
  
)

export default component.exports